import { useEffect, useState } from "react";

import {
  Wrapper,
  Wave,
  Content,
  Title,
  Description,
  Note,
  BannerImageWrap,
  BannerArt,
  BannerImage,
  CloudButton,
  ModalOverlay,
  SrOnly,
} from "./SchemesBanner.styles";

import schemesBanner from "../../../../assets/pages/landing/schemesBanner.svg";
import VirasatSchemePopup from "./VirasatSchemePopup";
import EducationLoanSchemePopup from "./EducationLoanSchemePopup";
import MicroFinanceSchemePopup from "./MicroFinanceSchemePopup";
import TermLoanSchemePopup from "./TermLoanSchemePopup";

const schemeClouds = [
  {
    id: "virasat",
    label: "Open Virasat Scheme",
    left: "0.2%",
    top: "33.5%",
    width: "20.2%",
    height: "30%",
  },
  {
    id: "education",
    label: "Open Education Loan Scheme",
    left: "17.2%",
    top: "1.6%",
    width: "25.4%",
    height: "37.5%",
  },
  {
    id: "microFinance",
    label: "Open Micro-Finance Scheme",
    left: "49.1%",
    top: "1%",
    width: "23.7%",
    height: "30.5%",
  },
  {
    id: "termLoan",
    label: "Open Term Loan Scheme",
    left: "77.2%",
    top: "16.2%",
    width: "22.8%",
    height: "33.8%",
  },
];

const schemePopups = {
  virasat: VirasatSchemePopup,
  education: EducationLoanSchemePopup,
  microFinance: MicroFinanceSchemePopup,
  termLoan: TermLoanSchemePopup,
};

const SchemesBanner = () => {
  const [activeScheme, setActiveScheme] = useState(null);
  const ActiveSchemePopup = activeScheme ? schemePopups[activeScheme] : null;

  const closeScheme = () => setActiveScheme(null);

  useEffect(() => {
    if (!activeScheme) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeScheme();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [activeScheme]);

  return (
    <Wrapper>
      <Wave />

      <Content>
        <Title>Your Gateway to NMDFC Schemes</Title>

        <Description>
          Easy access to education loans, business finance, skill development,
          and welfare schemes.
        </Description>

        <Note>Click on the speech bubbles to know more about the schemes</Note>
      </Content>
      <BannerImageWrap>
        <BannerArt>
          <BannerImage src={schemesBanner} alt="" />
          {schemeClouds.map((cloud) => (
            <CloudButton
              key={cloud.id}
              type="button"
              aria-label={cloud.label}
              $left={cloud.left}
              $top={cloud.top}
              $width={cloud.width}
              $height={cloud.height}
              onClick={() => setActiveScheme(cloud.id)}
            >
              <SrOnly>{cloud.label}</SrOnly>
            </CloudButton>
          ))}
        </BannerArt>
      </BannerImageWrap>

      {ActiveSchemePopup && (
        <ModalOverlay onClick={closeScheme}>
          <div onClick={(event) => event.stopPropagation()}>
            <ActiveSchemePopup onClose={closeScheme} />
          </div>
        </ModalOverlay>
      )}
    </Wrapper>
  );
};

export default SchemesBanner;
